import React from "react";
import { SovosBox, SovosChipFilter, SovosTypography } from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { useTheme } from "mosaic-react/styles";

const GeneratorEntity = (props) => {
    const { i18n } = useGlobalValue();
    const { value: cell } = props || {};
    const { entity, isMandatory } = cell || {};

    const theme = useTheme();
    const mandatoryTagColor = theme.palette.grey.A100;


    return (
        <SovosBox style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
            <SovosTypography sx={{ minWidth: "250px", fontSize: "12px" }} variant={"body1"}>
                {(entity || "").replace(/([A-Z])/g, " $1").trim()}
            </SovosTypography>
            {
                <SovosChipFilter
                    sx={{
                        fontSize: "12px",
                        height: 20,
                        marginLeft: 2,
                        background: isMandatory ? mandatoryTagColor : "",
                        width: "fit-content",
                    }}
                    label={isMandatory ? i18n`Mandatory` : i18n`Optional`}

                    />
                }
        </SovosBox>
    );
};

export default GeneratorEntity;
